export default class FeatureFlags {
  dashboardDrillDown: boolean
  jobAssignmentGroups: boolean
  weekViewDoubleHeightJobCard: boolean
  lineItems: boolean
  invoices: boolean
  userAccessScopes: boolean
  jobStopSkipping: boolean
  officeAutomationPromotion: boolean
  hideJobsSearchToggle: boolean
  customFieldGovernance: boolean
  bulkPdfExport: boolean
  enableTriggerStats: boolean
  fieldViewDateWindow: boolean
  constructor(json) {
    this.dashboardDrillDown = json.dashboard_drill_down
    this.jobAssignmentGroups = json.job_assignment_groups
    this.weekViewDoubleHeightJobCard = json.week_view_double_height_job_card
    this.lineItems = json.line_items
    this.invoices = json.invoices
    this.userAccessScopes = json.user_access_scopes
    this.jobStopSkipping = json.job_stop_skipping
    this.officeAutomationPromotion = json.office_automation_promotion
    this.hideJobsSearchToggle = json.hide_jobs_search_toggle
    this.customFieldGovernance = json.custom_field_governance
    this.bulkPdfExport = json.bulk_pdf_export
    this.enableTriggerStats = json.enable_trigger_stats
    this.fieldViewDateWindow = json.field_view_date_window
  }
}
